import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const manipulateModel = ({ data }, address, _zipCode) => {
  const { streetType, street, district, city, state } = address.data;

  let DataEntrega = data.deliveryDate.split('T')[0];

  DataEntrega = DataEntrega.split('-');

  const model = {
    code: _zipCode,
    address: `${streetType} ${street}`,
    district: `${district}`,
    city: `${city} - ${state}`,
    shippingValue: data.total,
    shippingValueCash: data.totalCash,
    deliveryForeCastDate: `${DataEntrega[2]}/${DataEntrega[1]}/${DataEntrega[0]}`,
  };

  return model;
};

export const getShipping = createAsyncThunk(
  'getShipping',
  async ({ participantCep, productSku }, { getState, rejectWithValue }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION,
      'Referer-Api': process.env.REACT_APP_ENVIRONMENT,
    };

    try {
      const responseShipping = await axios.get(
        `${process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT}/cloudloyalty/v2/products/sku/${productSku}/shipping/${participantCep}`,
        { headers: customHeaders }
      );

      const addressApi = await axios.get(
        `${process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT}/cloudloyalty/v1/addresses/${participantCep}`,
        { headers: customHeaders }
      );

      const response = manipulateModel(responseShipping, addressApi, participantCep)

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }

  });
